import Model from '@models/Model';

const timezones = ['Asia/Makassar', 'Asia/Jakarta', 'Asia/Jayapura'];

export class WeatherAPI extends Model {
  key = process.env.VUE_APP_WEATHER_API_SECRET;
  weathers = {};
  static timezones = timezones;
  loading = false;
  async fetchFromAPI(lat, lng) {
    let self = this;
    let url = `/weather/forecast?lat=${lat}&lng=${lng}`;
    try {
      let response = await this.getPromise(url);
      self.formatResponse(response.data);
    } catch (e) {
      $showError('Unable to fetch', 'weather-api');
    }
    // self.loading = false;
    return self.weathers;
  }
  async get({ lat, lng }) {
    this.loading = true;
    let weathers = await this.fetchFromAPI(lat, lng);
    this.loading = false;
    return weathers;
  }
  formatResponse(data) {
    let self = this;
    let today = $moment()
      .tz(timezones[0])
      .format('YYYY-MM-DD');
    data.daily.data.forEach((data) => {
      if (Object.keys(self.weathers).length > 3) {
        return;
      }
      let date = $moment.unix(data.time).format('YYYY-MM-DD');
      if (date >= today) {
        self.weathers[date] = data;
      }
    });
  }
}

export class Weather {
  icon = '';
  summary = '';
  temp = '';
  temp_min = '';
  temp_max = '';
  precipitation = '';
  humidity = '';
  pressure = '';
  wind = {
    bearing: '',
    speed: '',
  };
  date = '';
  time = '';
  dayOfWeek = '';

  constructor(data) {
    const dateTime = $moment.unix(data.time);
    this.summary = data.summary;
    this.icon = data.icon;
    this.temp = ((data.temperatureMin + data.temperatureMax) / 2).toFixed(2);
    this.temp_min = data.temperatureMin;
    this.temp_max = data.temperatureMax;
    this.humidity = data.humidity;
    this.pressure = data.pressure;
    this.precipitation = data.precipProbability * 100;
    this.wind.bearing = data.windBearing;
    this.wind.speed = data.windSpeed;
    this.date = dateTime.format('YYYY-MM-DD');
    this.dayOfWeek = dateTime.format('ddd');
  }
}
